import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimeConversionService {
  constructor() {}
  convertToTwelveHourFormat(time: any) {
    // Regular expression to match time in HH:MM format
    const timeRegex = /^(\d{2}):(\d{2})$/;

    if (typeof time === 'string') {
      const match = timeRegex.exec(time);
      if (match) {
        const [_, hours, minutes] = match;
        // Convert hours to number
        let hour = parseInt(hours, 10);
        // Determine if it's AM or PM
        const period = hour >= 12 ? 'PM' : 'AM';
        // Convert to 12-hour format
        hour = hour % 12 || 12;
        // Format hour to always have two digits
        const formattedHour = hour < 10 ? `0${hour}` : `${hour}`;
        // Return the time in 12-hour format
        return `${formattedHour}:${minutes} ${period}`;
      }
    }
    // If the input time does not match the HH:MM format, return it as is
    return time;
  }
}
